import { render } from "./StrategyDropdownOptions.vue?vue&type=template&id=6b785581&lang=true"
import script from "./StrategyDropdownOptions.vue?vue&type=script&lang=js"
export * from "./StrategyDropdownOptions.vue?vue&type=script&lang=js"
script.render = render

export default script